import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { titleSetRef } from "../../redux/titleRedux";
import { useCompany } from "../../components/context/CompanyContext";
import { useEffect, useState } from "react";
export default function Chatbot() {
  const dispatch = useDispatch();
  const { hootspy } = useCompany();
  const [urlHootspy, setUrlHootspy] = useState(null);

  dispatch(titleSetRef({ title: "MoodaChat" }));

  useEffect(() => {
    if (hootspy) {
      //const url = `https://liteapp.com.br/InboxWidget?organizationId=68d9a3a44880f52272846b15&apiKey=hootspy_68d9a3a4_aojshuu2&password=@Hootspy6878&groupId=${hootspy}`;
      const url = `https://liteapp.com.br/InboxWidget?organizationId=68eb96282d6bd50717119038&groupId=${hootspy}&apiKey=hootspy_org_68eb96282d6bd50717119038_pp2ve3dyikc&password=@Hootspy6878`;

      setUrlHootspy(url);
    } else {
      setUrlHootspy(null);
    }
  }, [hootspy]);
  return (
    <div className="cust-page">
      {urlHootspy ? (
        <>
          <iframe
            src={urlHootspy}
            title="MoodaChat"
            style={{
              width: "100%",
              height: "100vh",
              border: "none",
            }}
          />
        </>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "80vh",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "2rem", color: "#333", marginBottom: "10px" }}>
            Acesso ao MoodaChat indisponível
          </h1>
          <p style={{ fontSize: "1.2rem", color: "#555", maxWidth: "400px" }}>
            Parece que você ainda não tem permissão para usar o MoodaChat.
            <br />
            Entre em contato com o administrador para obter acesso.
          </p>
        </div>
      )}
    </div>
  );
}
